exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal__ChangeLocationModal-module___3LicA {\n    background-color: #0000001d;\n}\n\n.container__ChangeLocationModal-module___PVnWn {\n    min-height: 155px;\n}", ""]);

// Exports
exports.locals = {
	"modal": "modal__ChangeLocationModal-module___3LicA",
	"container": "container__ChangeLocationModal-module___PVnWn"
};